import React from 'react';
import PropTypes from 'prop-types';
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { cookieDeclineToast } from './cookie.Decline.toast';
import { logout } from '../../../../api/functions/func/function.logout';
import DOMPurify from 'dompurify';

const CookieConsentComponent = ({ 
  cookiesDialogOpen, 
  setCookiesDialogOpen, 
  cookiesContent,
  type
}) => {

  const handleDecline = () => {
    localStorage.setItem('cookieAccepted', JSON.stringify(false));
    setCookiesDialogOpen(false);
    cookieDeclineToast();
    if (type === 'system') {
      setTimeout(logout, 4000);
    }
  };

  const handleAccept = () => {
    localStorage.setItem('cookieAccepted', JSON.stringify(true));
    setCookiesDialogOpen(false);
  };

  if (!cookiesContent || !cookiesDialogOpen) return null;

  const dialogContent = (
    <div>
      <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(cookiesContent) }} />
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '1rem', gap: '1rem' }}>
        <ButtonComponent
          className='e-control e-btn policy-button'
          onClick={handleDecline}
        >
          {navigator.language === 'de-DE' ? 'Ablehnen' : 'Decline'}
        </ButtonComponent>
        <ButtonComponent
          className='e-control e-btn policy-button'
          onClick={handleAccept}
        >
          {navigator.language === 'de-DE' ? 'Alles akzeptieren' : 'Accept all'}
        </ButtonComponent>
      </div>
    </div>
  );

  return (
    <DialogComponent
      visible={cookiesDialogOpen}
      closeOnEscape={false}
      showCloseIcon={true}
      isModal
      width="30%"
      height="50%"
      content={() => dialogContent}
      overlayClick={() => setCookiesDialogOpen(false)}
      close={() => setCookiesDialogOpen(false)}
    />
  );
};

CookieConsentComponent.propTypes = {
  cookiesDialogOpen: PropTypes.bool,
  setCookiesDialogOpen: PropTypes.func,
  cookiesContent: PropTypes.any,
  type: PropTypes.string
};

export default CookieConsentComponent;
